import { render, staticRenderFns } from "./DifferenzeDuplica.vue?vue&type=template&id=056690f6&scoped=true&"
import script from "./DifferenzeDuplica.vue?vue&type=script&lang=js&"
export * from "./DifferenzeDuplica.vue?vue&type=script&lang=js&"
import style0 from "./DifferenzeDuplica.vue?vue&type=style&index=0&id=056690f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056690f6",
  null
  
)

export default component.exports